/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_StartInputs */

const en_us2_session_start = /** @type {(inputs: Session_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start session`)
};

const pt_br2_session_start = /** @type {(inputs: Session_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar treino`)
};

const es_419_session_start = /** @type {(inputs: Session_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar entrenamiento`)
};

const pt_pt2_session_start = /** @type {(inputs: Session_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar treino`)
};

const fr_fr2_session_start = /** @type {(inputs: Session_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer la séance`)
};

const de_de2_session_start = /** @type {(inputs: Session_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheit starten`)
};

const it_it2_session_start = /** @type {(inputs: Session_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia sessione`)
};

/**
* | output |
* | --- |
* | "Start session" |
*
* @param {Session_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const session_start = /** @type {((inputs?: Session_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_session_start(inputs)
	if (locale === "es-419") return es_419_session_start(inputs)
	if (locale === "pt-PT") return pt_pt2_session_start(inputs)
	if (locale === "fr-FR") return fr_fr2_session_start(inputs)
	if (locale === "de-DE") return de_de2_session_start(inputs)
	if (locale === "it-IT") return it_it2_session_start(inputs)
	return en_us2_session_start(inputs)
});
export { session_start as "session.start" }